import { BaSeLoadingPage } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { GtmInjection } from './modules/candidate/components/gtm-injection';
import { LayoutCandidateQuiz } from './modules/candidate/components/layot-candidate-quiz';
import { LayoutCandidate } from './modules/candidate/components/layout-candidate';
import { QuizProfileProvider } from './modules/candidate/components/quiz-profile/context/QuizContext';
import QuizProfile from './modules/candidate/components/quiz-profile/quiz-profile';
import { AboutCourse } from './modules/candidate/pages/about-course/about-course';
import { CandidateHome } from './modules/candidate/pages/candidate-home';
import { CandidateInterview } from './modules/candidate/pages/candidate-interview/candidate-interview';
import { LinkExpirado } from './modules/candidate/pages/johari/LinkExpirado';
import { StepProvider } from './modules/candidate/pages/johari/context/StepContext';
import { Johari } from './modules/candidate/pages/johari/johari';
import { Result } from './modules/candidate/pages/johari/result';
import { ResultFail } from './modules/candidate/pages/johari/result-fail';
import ResultFailQuiz from './modules/candidate/pages/quiz/result-fail';
import ResultSucess from './modules/candidate/pages/quiz/result-success';
import Report from './modules/candidate/pages/report/report';
import ReportDetail from './modules/candidate/pages/report/report-detail/report-detail';
import { ResultContent } from './modules/candidate/pages/result/result-content';
import Index from './modules/landing-page';
import { Layout } from './modules/manager/components/layout';
import { TableInterviewProvider } from './modules/manager/context/table-interview-context';
import { AmeiManagement } from './modules/manager/pages/amei-management/amei-management';
import { Candidates } from './modules/manager/pages/candidates/candidates';
import { AvaliableRuralProvider } from './modules/manager/pages/candidates/context/avaliable-rural-candidate';
import { NewClassRoomProvider } from './modules/manager/pages/candidates/context/new-class-room-context';
import { SeeAnswersNotesProvider } from './modules/manager/pages/candidates/context/see-answers-notes-context';
import { ManagerHome } from './modules/manager/pages/manager-home';
import { Settings } from './modules/manager/pages/settings/settings';

const ModuleValidator = React.lazy(() =>
  import('./utils/validators/module-validator'),
);

const routesGestor = () => {
  return [
    {
      routePath: '/gestor/validate/:token',
      isExactPath: true,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <Layout showFooter>
            <NewClassRoomProvider>
              <ManagerHome />
            </NewClassRoomProvider>
          </Layout>
        </React.Suspense>
      ),
    },
    {
      routePath: '/gestor',
      isExactPath: true,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <Layout showFooter>
            <NewClassRoomProvider>
              <ManagerHome />
            </NewClassRoomProvider>
          </Layout>
        </React.Suspense>
      ),
    },
    {
      routePath: '/gestor/entrevista',
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR', 'GESTOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ModuleValidator>
            <Layout showFooter>
              <NewClassRoomProvider>
                <SeeAnswersNotesProvider>
                  <Candidates />
                </SeeAnswersNotesProvider>
              </NewClassRoomProvider>
            </Layout>
          </ModuleValidator>
        </React.Suspense>
      ),
    },

    {
      routePath: '/gestor/configuracoes',
      isExactPath: true,
      ifHaveTheseRoles: ['ADMINISTRADOR'],
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ModuleValidator>
            <Layout>
              <Settings />
              {/* <CalibrateNotes /> */}
            </Layout>
          </ModuleValidator>
        </React.Suspense>
      ),
    },

    {
      routePath: '/gestor/amei',
      isExactPath: true,
      ifIsAuthenticated: true,
      orRedirectTo: '/gestor',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ModuleValidator>
            <Layout>
              <AmeiManagement />
            </Layout>
          </ModuleValidator>
        </React.Suspense>
      ),
    },
  ];
};

const routesQuizProfile = () => {
  // candidato/questionario/perfil?module=1&interview=2
  return [
    {
      routePath: '/candidato/questionario/perfil/interview',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <QuizProfileProvider>
            <LayoutCandidateQuiz>
              <QuizProfile />
            </LayoutCandidateQuiz>
          </QuizProfileProvider>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/questionario/perfil/interview/sucesso',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <QuizProfileProvider>
            <LayoutCandidateQuiz>
              <ResultSucess />
            </LayoutCandidateQuiz>
          </QuizProfileProvider>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/questionario/perfil/interview/falha',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <QuizProfileProvider>
            <LayoutCandidateQuiz>
              <ResultFailQuiz />
            </LayoutCandidateQuiz>
          </QuizProfileProvider>
        </React.Suspense>
      ),
    },
  ];
};

const routesCandidate = () => {
  return [
    {
      routePath: '/',
      isExactPath: true,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <CandidateHome />
          </GtmInjection>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato',
      orRedirectTo: '/',
      isExactPath: true,
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <CandidateInterview />
          </GtmInjection>
        </React.Suspense>
      ),
    },

    {
      routePath: '/candidato/sobre-curso',
      isExactPath: true,
      ifIsAuthenticated: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <AboutCourse />
          </GtmInjection>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/resultado',
      isExactPath: true,
      ifIsAuthenticated: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <ResultContent />
          </GtmInjection>
        </React.Suspense>
      ),
    },
    //rotas acessadas pelos adm
    {
      routePath: '/candidato/id/:id',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <CandidateInterview />
          </GtmInjection>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/sobre-curso/id/:id',
      isExactPath: true,
      ifIsAuthenticated: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <AboutCourse />
          </GtmInjection>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/resultado/id/:id',
      isExactPath: true,
      ifIsAuthenticated: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <GtmInjection>
            <ResultContent />
          </GtmInjection>
        </React.Suspense>
      ),
    },
  ];
};

const routesJohari = () => {
  return [
    {
      routePath: '/candidato/questionario',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LayoutCandidate>
              <Johari />
            </LayoutCandidate>
          </StepProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/:module/questionario/:cpf',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LayoutCandidate>
              <Johari />
            </LayoutCandidate>
          </StepProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/questionario/link-expirado',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LinkExpirado />
          </StepProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/questionario/resultado',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LayoutCandidate>
              <Result />
            </LayoutCandidate>
          </StepProvider>
        </React.Suspense>
      ),
    },
    {
      routePath: '/candidato/questionario/resultado/falhou',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <StepProvider>
            <LayoutCandidate>
              <ResultFail />
            </LayoutCandidate>
          </StepProvider>
        </React.Suspense>
      ),
    },
  ];
};

const routesRelatorio = () => {
  return [
    {
      routePath: '/relatorio',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <Report />
        </React.Suspense>
      ),
    },
    {
      routePath: '/relatorio/:cpf',
      isExactPath: true,
      orRedirectTo: '/candidato',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <ReportDetail />
        </React.Suspense>
      ),
    },
  ];
};

const routesApresentation = () => {
  return [
    {
      routePath: '/portal',
      isExactPath: true,
      orRedirectTo: '/',
      pageToRender: (
        <React.Suspense fallback={<BaSeLoadingPage />}>
          <Index />
        </React.Suspense>
      ),
    },
  ];
};

export const Routes = () => (
  <TableInterviewProvider>
    <AvaliableRuralProvider>
      <Sebrae.Routes
        routes={[
          ...routesApresentation(),
          ...routesRelatorio(),
          ...routesGestor(),
          ...routesCandidate(),
          ...routesJohari(),
          ...routesQuizProfile(),
        ]}
      />
    </AvaliableRuralProvider>
  </TableInterviewProvider>
);
